export default __webpack_public_path__ + "static/media/ciudad.85844e47.svg";